<template>
  <div class="login-wrapper">
    <CustomHeader :theme-vars="navBarThemeVars" />
    <slot></slot>
  </div>
</template>

<script>
import CustomHeader from "@/components/customHeader/index.vue"
export default {
  name: "LoginWrapper",
  data() {
    return {
      navBarThemeVars: {
        navBarTextColor: "#fff",
        navBarBackgroundColor: "transparent",
      },
    }
  },
  props: {
    plateformType: {
      type: String,
      default: "webapp",
    },
  },
  components: {
    CustomHeader,
  },
}
</script>

<style lang="less" scoped>
.login-wrapper {
  position: relative;
  height: 100vh;
  background-color: #4174fd;
  background: #4174fd url("~@/assets/image/bg.jpg") no-repeat top left/100%;
}
</style>
